import { createApp } from 'vue';
import App from './App.vue';
import './assets/nocturne.css';

createApp(App).mount('#app')
